import { Box, Container, Link, Stack, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import imgHome from "../assets/screenshots/light-home.png";
import imgYearly from "../assets/screenshots/light-yearly.png";
import imgMonthly from "../assets/screenshots/light-monthly.png";
import imgWeekly from "../assets/screenshots/light-weekly.png";
import imgDaily from "../assets/screenshots/light-daily.png";
import imgInfo from "../assets/screenshots/light-info.png";
import imgInfoProgress from "../assets/screenshots/light-list-progress.png";
import _ from "lodash";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

const images = [
  imgHome,
  imgYearly,
  imgMonthly,
  imgWeekly,
  imgDaily,
  imgInfo,
  imgInfoProgress,
];

function Gallery() {
  return (
    <div id="gallery">
      <Container maxWidth="lg" sx={{ paddingY: 5 }}>
        <Typography variant="h3" marginBottom={3}>
          Gallery
        </Typography>
        <Stack direction="row">
          <Box flexGrow={1} overflow="hidden">
            <Swiper
              spaceBetween={16}
              slidesPerView="auto"
              modules={[Autoplay, Pagination, Navigation]}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              className="gallery-swiper"
              breakpoints={{
                768: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
              }}
            >
              {_.map(images, (item, index) => (
                <SwiperSlide key={index} className="gallery-slide">
                  <img className="gallary-img" src={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
          <Stack flexShrink={0} padding={4} justifyContent="center">
            <Link color="textPrimary" underline="none" href="#download-app">
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                className="blinking"
              >
                <Typography variant="subtitle1">Install me</Typography>
                <DownloadForOfflineIcon sx={{ fontSize: 20 }} />
              </Stack>
            </Link>
            <Typography variant="body2">To see more</Typography>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}

export default Gallery;
